import { PAGE_LEVEL_ERROR, UPDATE_ALERT, UPDATE_USER } from "./../store/types";
import { useContext, useState } from "react";
import { DispatchContext, StateContext } from "./../store/context";
import API from "../network";
import { useNavigate } from "react-router";
import ROUTES from "../setup/routes";

export const useFetchApi = (
  url: string,
  data: any = {},
  method: any = "POST",
  onSuccess?: any,
) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [response, setResponse] = useState<any>(null);
  const dispatch = useContext(DispatchContext);

  const { authUser } = useContext(StateContext);

  const role_id = authUser?.role_id;

  const execute = (exdata?: any, headers?: any) => {
    setLoading(true);
    dispatch({ type: UPDATE_ALERT, payload: null });
    const Authorization = localStorage.getItem("token") || "";

    API(url, {
      data: exdata ? exdata : data,
      method,
      headers: { ...headers, Authorization, role_id },
    })
      .then((response: any) => {
        setLoading(false);
        if (response.status === 200) {
          const { data, status = "", message = "" } = response.data;
          // console.log('data', data);
          if (data) {
            console.log("useFetchAPI: ", data);
            setResponse(data);
          }

          if (status && status === "error") {
            dispatch({
              type: PAGE_LEVEL_ERROR,
              payload: { message },
            });
            return;
          } else if (status) {
            dispatch({
              type: UPDATE_ALERT,
              payload: { type: status, message },
            });
            if (onSuccess) {
              onSuccess();
            }
            // navigate(successRedirect);
          }
        }
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.message.includes("401")) {
          localStorage.removeItem("token");
          sessionStorage.removeItem("state");
          dispatch({ type: UPDATE_USER, payload: null });
          navigate(ROUTES.LOGIN);
        }
        console.log("error", error);
        // if(response.status === "error") {
        //   console.log('e',response, response.status);
        //   dispatch({
        //     type: UPDATE_ALERT,
        //     payload: { type: response.status, message: response.message },
        //   });
        // }
        console.log("err", error);
      });
  };

  return { loading, execute, response };
};
